export default function() {
  var size = 0;
  this.visit(function(node) {
    if (!node.length) do ++size; while (node = node.next)
  });
  return size;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-quadtree/src/size.js
// module id = 356
// module chunks = 0 1 2 3 4